/** Colour arrows: images are requested on demand, without thumbnail images. */
class MadamCardColors extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    const data=this.querySelector('[data-colour-data]');
    if (!data) return;
    try { this.colors=JSON.parse(data.textContent); } catch { return; }
    if (!Array.isArray(this.colors)||!this.colors.length) return;
    this._ready=true;
    this.card=this.closest('product-card');this.image=this.querySelector('.mc-colour-photo');
    this.index=0;
    this.querySelectorAll('[data-colour-step]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();this.select((this.index+Number(b.dataset.colourStep)+this.colors.length)%this.colors.length)}));
  }
  select(i){
    const c=this.colors[i];if(!c)return;this.index=i;
    this.image.alt=this.dataset.title+' — '+c.color;
    this.querySelector('.mc-colour-main')?.setAttribute('aria-label',this.image.alt);
    const srcset=[360,600,900].map(w=>{const u=new URL(c.src,location.origin);u.searchParams.set('width',w);return u.href+' '+w+'w'}).join(', ');this.image.srcset=srcset;this.image.src=c.src;
    const links=this.card?.querySelectorAll('a[href]')||this.querySelectorAll('a[href]');
    links.forEach(a=>{const u=new URL(a.href,location.origin);if(u.pathname.includes('/products/'))a.href=c.url});
    if(this.card){
      this.card.dataset.featuredMediaUrl=c.src;
      this.card.querySelectorAll('[ref="priceContainer"]').forEach(p=>{
        p.querySelectorAll('.price').forEach(el=>el.textContent=c.price);
        p.querySelectorAll('.compare-at-price').forEach(el=>el.textContent=c.compare);
        p.querySelector('.price__regular')?.classList.toggle('price__hidden',c.sale);
        p.querySelector('.price__sale')?.classList.toggle('price__hidden',!c.sale);
      });
      const badge=this.card.querySelector('.product-badges__badge');if(badge){badge.textContent=!c.available?'Tükendi':'İndirimde';badge.hidden=c.available&&!c.sale}
    }
  }
}
if(!customElements.get('mc-card-colors'))customElements.define('mc-card-colors',MadamCardColors);
